import React from 'react';
import { ErrorState } from './States';
import Button from './Button';

interface Props { children: React.ReactNode; resetKey?: string }
interface State { error: Error | null }

/** 한 페이지의 렌더 오류가 앱 전체를 흰 화면으로 만들지 않도록 막습니다. */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorState
          title="화면을 표시하는 중 문제가 발생했습니다"
          description="일시적인 데이터 오류일 수 있습니다. 다시 시도하거나 다른 메뉴로 이동해 주세요."
          action={<Button variant="secondary" onClick={() => this.setState({ error: null })}>다시 시도</Button>}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
